import { deluge } from '@/stores/deluge.js';

let notificationCounter = 0;

/**
 * Sends a Notification to the Front End
 * @param {string} msg - message to display
 * @param {number} time - time displayed in milliseconds
 * @param {string} type -  'success', 'info', 'note', 'warning', 'error'
 */
export function clientNotification(msg, time = 3500, type = 'info') {
  if ((!type) in ['success', 'info', 'note', 'warning', 'error']) type = 'info';

  const id = notificationCounter++;

  let data = {};
  data[id] = { msg: msg, expires: 60, type: type };

  deluge.$user_system.notify = {
    ...deluge.$user_system.notify,
    ...data,
  };

  setTimeout(() => {
    delete deluge.$user_system.notify[id];
  }, time);
}
